// extracted by mini-css-extract-plugin
export default {"xAxisLabels":"styles_xAxisLabels__ZAj6f","yAxisTitle":"styles_yAxisTitle__2fpKx"};